export default __webpack_public_path__ + "static/media/d10.67bb9f09.png";